import React, { useState, useEffect } from "react";
import {
  Modal,
  Form,
  Button,
  Alert,
  FloatingLabel
} from "react-bootstrap";
import axios from "axios";
import { API_ENDPOINTS } from '../config/api';

const AttendanceTracker = ({ show, onHide, session, onAttendanceRecorded }) => {
  const [attendanceCode, setAttendanceCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    if (show) {
      setAttendanceCode("");
      setError("");
      setSuccess("");
    }
  }, [show]);

  const handleSubmitAttendance = async (e) => {
    e.preventDefault();
    
    if (!attendanceCode.trim()) {
      setError("Please enter the attendance code");
      return;
    }

    try {
      setLoading(true);
      setError("");
      
      const response = await axios.post(
        `${API_ENDPOINTS.CONFERENCE_ATTENDANCE}/record`,
        {
          sessionId: session.id,
          attendanceCode: attendanceCode.trim().toUpperCase()
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        }
      );

      setSuccess("Attendance recorded successfully!");
      setAttendanceCode("");
      
      // Notify parent component to refresh attendance data
      if (onAttendanceRecorded) {
        onAttendanceRecorded();
      }
      
      setTimeout(() => {
        setSuccess("");
        onHide(); // Close modal after successful recording
      }, 2000);
    } catch (error) {
      console.error("Error recording attendance:", error);
      setError(error.response?.data?.error || "Failed to record attendance");
    } finally {
      setLoading(false);
    }
  };

  if (!session) return null;

  return (
    <Modal show={show} onHide={onHide} size="md">
      <Modal.Header className="px-4 border-bottom-0" closeButton>
        <Modal.Title className="w-50"><div className="d-flex flex-column justify-content-start align-items-start">
            <span>Record Attendance</span>
            <div className="text-hl"></div>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-4">
        {error && <Alert variant="danger">{error}</Alert>}
        {success && <Alert variant="success">{success}</Alert>}

        <Form onSubmit={handleSubmitAttendance}>
          <Form.Group>
            <FloatingLabel label="Enter Attendance Code" controlId="floatingInput">
            <Form.Control
              type="text"
              value={attendanceCode}
              onChange={(e) => setAttendanceCode(e.target.value)}
              placeholder="Enter 7-character attendance code"
              maxLength={7}
              style={{ textTransform: 'uppercase' }}
              autoFocus
            />
            </FloatingLabel>
            <Form.Text className="text-muted">
              Enter the attendance code provided for this conference session.
            </Form.Text>
          </Form.Group>
          <Button
            type="submit"
            variant="primary"
            disabled={loading}
            className="w-100 mb-3 mt-4"
          >
            {loading ? "Recording..." : "Record Attendance"}
          </Button>
        </Form>
      </Modal.Body>        
    </Modal>
  );
};

export default AttendanceTracker; 